var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconExport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.533 8.267a1.8 1.8 0 0 1 1.8 1.8V18.2a1.8 1.8 0 0 1-1.8 1.8H7.4a1.8 1.8 0 0 1-1.8-1.8v-8.133a1.8 1.8 0 0 1 1.8-1.8h2.111v1.466H8.267a1.2 1.2 0 0 0-1.2 1.2v6.4a1.2 1.2 0 0 0 1.2 1.2h6.4a1.2 1.2 0 0 0 1.2-1.2v-6.4a1.2 1.2 0 0 0-1.2-1.2h-1.245V8.267h2.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.835 2.904a.6.6 0 0 1 .105.105l2.196 2.823a.6.6 0 0 1-.474.968h-1.416c.007.036.01.073.01.111v6.622a.6.6 0 0 1-.6.6h-.38a.6.6 0 0 1-.6-.6V6.911c0-.038.004-.075.011-.112L9.271 6.8a.6.6 0 0 1-.473-.968l2.195-2.823a.6.6 0 0 1 .842-.105z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconExport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-export.a8cbdc8117f7d4b87ca9887c12c63650.svg";